var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('sf-data-table',{attrs:{"pageUnit":_vm.groups.pageUnit,"totalSize":_vm.groups.totalSize,"currentPage":_vm.groups.currentPage,"paging":"","columns":_vm.columns,"rows":this.resultList,"excel":_vm.isButton_(_vm.scrId, 'EX')},on:{"changedPage":_vm.changedPage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }